export const categories = [ 'Aguas', 'Ambiente - Ley General del Ambiente', 'Aspectos Generales de Protección del Ambiente', 'Combustible - Tanques para Consumo Propio', 'Efluentes Líquidos', 'Emisiones gaseosas', 'Evaluación de Impacto Ambiental', 'Gestión Ambiental de Parques Solares', 'Ley de educación ambiental', 'Neumáticos Fuera de Uso', 'Ordenamiento Territorial, uso y fraccionamiento del suelo', "PCB's", 'Residuos Patogénicos', 'Residuos Peligrosos', 'Residuos Sólidos', 'Seguro Ambiental', 'Tanques Aéreos de Combustible' ];


export function slugify(text) {
  return text.toString().toLowerCase()
    .normalize('NFD').replace(/\p{Diacritic}/gu, '')
    .trim().replace(/\s+/g, '-').replace(/-+/g, '-')
    .replace(/,/g, '').replace(/'/g, '');
}
